import { useLocation } from 'react-router-dom';
import { t } from '../i18n';

const titles: Record<string, string> = {
  '/': t().dashboard.title,
  '/customers': t().nav.customers,
  '/customers/new': t().customers.new,
  '/shipment-files': t().nav.shipmentFiles,
  '/shipment-files/new': t().shipmentFiles.new,
  '/invoices': t().nav.invoices,
  '/invoices/new': t().invoices.new,
  '/payments': t().nav.payments,
  '/payments/new': t().payments.new,
  '/mydata': t().nav.mydataPeriod,
  '/mydata/sync': t().nav.mydataSync,
  '/mydata/debts': t().nav.mydataDebts,
  '/mydata/documents': t().nav.mydataDocuments,
  '/mydata/pdf-export': t().nav.mydataPdfExport,
  '/settings/mydata-connection': t().nav.mydataConnection,
  '/reports/monthly-summary': t().nav.monthlySummary,
  '/reports/yearly-monthly': t().nav.yearlyMonthly,
  '/reports/customer-balances': t().nav.customerBalances,
  '/reports/aging': t().nav.aging,
  '/reports/category-summary': t().nav.categorySummary,
  '/reports/unallocated-payments': t().nav.unallocatedPayments,
  '/reports/agreement-variance': t().nav.agreementVariance,
  '/reports/shipment-monthly-summary': t().nav.shipmentMonthlySummary,
  '/reports/shipment-expense-categories': t().nav.shipmentExpenseCategories,
  '/reports/shipment-open-files': t().nav.shipmentOpenFiles,
  '/reports/shipment-by-customer': t().nav.shipmentByCustomer,
  '/reports/shipment-container-bl': t().nav.shipmentContainerBl,
  '/reports/shipment-expense-analysis': t().nav.shipmentExpenseAnalysis,
  '/reports/shipment-by-port-vessel': t().nav.shipmentByPortVessel,
  '/settings/invoice-categories': t().nav.invoiceCategories,
  '/settings/expense-categories': t().nav.expenseCategories,
  '/settings/offices': t().nav.office,
  '/settings/users': t().nav.users,
  '/platform/tenants': t().platform.tabTenants,
  '/platform/packages': t().platform.tabPackages,
  '/platform/admins': t().platform.tabAdmins,
  '/platform/settings': t().platform.tabSettings,
  '/platform/audit-logs': t().platform.tabAuditLogs,
  '/setup/company': t().tenantSetup.title,
};

export function usePageTitle(): string {
  const { pathname } = useLocation();

  if (pathname.match(/^\/customers\/\d+\/edit$/)) {
    return t().customers.edit;
  }
  if (pathname.match(/^\/customers\/\d+$/)) {
    return t().customers.details;
  }
  if (pathname.match(/^\/shipment-files\/\d+\/edit$/)) {
    return t().shipmentFiles.edit;
  }
  if (pathname.match(/^\/shipment-files\/\d+$/)) {
    return t().shipmentFiles.details;
  }
  if (pathname.match(/^\/invoices\/\d+\/edit$/)) {
    return t().invoices.edit;
  }
  if (pathname.match(/^\/invoices\/\d+$/)) {
    return t().invoices.details;
  }
  if (pathname.match(/^\/payments\/\d+\/edit$/)) {
    return t().payments.edit;
  }
  if (pathname.match(/^\/payments\/\d+$/)) {
    return t().payments.details;
  }
  if (pathname.match(/^\/mydata\/documents\//)) {
    return t().mydata.documentTitle;
  }

  return titles[pathname] ?? t().app.name;
}
